import { Action } from 'redux';

// vehicle testapi
export const SUPER_GET_VEHICLES = 'super-admin-financial-report/SUPER_GET_VEHICLES';
export const getSuperVehicles = () => ({
  type: SUPER_GET_VEHICLES,
});

export const SUPER_SET_VEHICLES = 'super-admin-financial-report/SUPER_SET_VEHICLES';
export const setSuperSuperVehicles = (data: ReadonlyArray<ReconciliationEntriesTable>) => ({
  type: SUPER_SET_VEHICLES,
  payload: data,
});

export interface SuperSetVehicleList extends Action<typeof SUPER_SET_VEHICLES> {
  payload: ReadonlyArray<any>;
}

export const SUPER_GET_RECONCILIATION_ENTRIES = 'super-admin-financial-report/SUPER_GET_RECONCILIATION_ENTRIES';
export const getSuperReconciliationEntries = (data: SelectReportData) => ({
  type: SUPER_GET_RECONCILIATION_ENTRIES,
  payload: data,
});

export const SUPER_SET_RECONCILIATION_ENTRIES = 'super-admin-financial-report/SUPER_SET_RECONCILIATION_ENTRIES';
export const setSuperReconciliationEntries = (data: ReadonlyArray<ReconciliationEntriesTable>) => ({
  type: SUPER_SET_RECONCILIATION_ENTRIES,
  payload: data,
});

// reconociliation
export const SUPER_GET_RECONCILIATION_DATA = 'super-admin-financial-report/SUPER_GET_RECONCILIATION_DATA';
export const getSuperReconciliationData = (data: SelectReportData) => ({
  type: SUPER_GET_RECONCILIATION_DATA,
  payload: data,
});

export const SUPER_SET_RECONCILIATION_DATA = 'super-admin-financial-report/SUPER_SET_RECONCILIATION_DATA';
export const setSuperReconciliationData = (data: ReadonlyArray<any>) => ({
  type: SUPER_SET_RECONCILIATION_DATA,
  payload: data,
});
// reconociliation superadmin
export const SUPER_GET_RECONC_DATA = 'super-admin-financial-report/SUPER_GET_RECONC_DATA';
export const getSuperReconData = (data: SelectReportData) => ({
  type: SUPER_GET_RECONC_DATA,
  payload: data,
});

export const SUPER_SET_RECONC_DATA = 'super-admin-financial-report/SUPER_SET_RECONC_DATA';
export const setSuperReconData = (data: ReadonlyArray<any>) => ({
  type: SUPER_SET_RECONC_DATA,
  payload: data,
});
//
export interface SuperSetReconcAction extends Action<typeof SUPER_SET_RECONC_DATA> {
  payload: ReadonlyArray<any>;
}
// reconociliation superadmin  end
// recon clientadmin start
export const CLIENT_GET_RECONC_DATA = 'super-admin-financial-report/CLIENT_GET_RECONC_DATA';
export const getClientReconData = () => ({
  type: CLIENT_GET_RECONC_DATA,
});

export const CLIENT_SET_RECONC_DATA = 'super-admin-financial-report/CLIENT_SET_RECONC_DATA';
export const setClientReconData = (data: ReadonlyArray<any>) => ({
  type: CLIENT_SET_RECONC_DATA,
  payload: data,
});
//
export interface ClientSetReconcAction extends Action<typeof CLIENT_SET_RECONC_DATA> {
  payload: ReadonlyArray<any>;
}
// recon clientadmin end

//  reconcilation adjustments
export const SUPER_GET_RECONCILIATION_ADJUSTMENTS_DATA =
  'super-admin-financial-report/SUPER_GET_RECONCILIATION_ADJUSTMENTS_DATA';
export const getSuperReconciliationAdjustmentData = (data: SelectReportData) => ({
  type: SUPER_GET_RECONCILIATION_ADJUSTMENTS_DATA,
  payload: data,
});

export const SUPER_SET_RECONCILIATION_ADJUSTMENTS_DATA =
  'super-admin-financial-report/SUPER_SET_RECONCILIATION_ADJUSTMENTS_DATA';
export const setSuperReconciliationAdjustmentData = (data: ReadonlyArray<any>) => ({
  type: SUPER_SET_RECONCILIATION_ADJUSTMENTS_DATA,
  payload: data,
});
export interface SuperSetReconciliatioAdjustmentDataAction extends Action<
  typeof SUPER_SET_RECONCILIATION_ADJUSTMENTS_DATA
> {
  payload: ReadonlyArray<any>;
}
//  reconcilation adjustments end

//multiple client table//
export interface SuperSetReconciliationAction extends Action<typeof SUPER_SET_RECONCILIATION_ENTRIES> {
  payload: ReadonlyArray<ReconciliationEntriesTable>;
}

export interface SuperSetReconciliatioDataAction extends Action<typeof SUPER_SET_RECONCILIATION_DATA> {
  payload: ReadonlyArray<any>;
}

// create reconciliation
export const GET_CREATE_RECONCILIATION = 'super-admin-financial-report/GET_CREATE_RECONCILIATION';
export const getCreateReconciliation = (data: any, onComplete?: () => void) => ({
  meta: {
    onComplete,
  },
  type: GET_CREATE_RECONCILIATION,
  payload: data,
});
export const SET_CREATE_RECONCILIATION = 'super-admin-financial-report/SET_CREATE_RECONCILIATION';
export const setCreateReconciliation = (data: any, onComplete?: () => void) => ({
  meta: {
    onComplete,
  },
  type: SET_CREATE_RECONCILIATION,
  payload: data,
});

export interface CreateReconciliationAction extends Action<typeof SET_CREATE_RECONCILIATION>, OnCompleteAction {
  readonly payload: any;
}
// edit reconciliation
export const GET_EDIT_RECONCILIATION = 'super-admin-financial-report/GET_EDIT_RECONCILIATION';
export const getEditReconciliation = (data: any, onComplete?: () => void) => ({
  meta: {
    onComplete,
  },
  type: GET_EDIT_RECONCILIATION,
  payload: data,
});
export const SET_EDIT_RECONCILIATION = 'super-admin-financial-report/SET_EDIT_RECONCILIATION';
export const setEditReconciliation = (data: any, onComplete?: () => void) => ({
  meta: {
    onComplete,
  },
  type: SET_EDIT_RECONCILIATION,
  payload: data,
});

export interface EditReconciliationAction extends Action<typeof SET_EDIT_RECONCILIATION>, OnCompleteAction {
  readonly payload: any;
}

// end edit reconciliation

// create reconcile payments
export const GET_CREATE_RECONCILIATION_PAYMENTS = 'super-admin-financial-report/GET_CREATE_RECONCILIATION_PAYMENTS';
export const getCreateReconciliationPayments = (
  data: { readonly values: ApiReconciliationPaymentValues; readonly client: string },
  onComplete?: () => void,
) => ({
  meta: {
    onComplete,
  },
  type: GET_CREATE_RECONCILIATION_PAYMENTS,
  payload: data,
});
export const SET_CREATE_RECONCILIATION_PAYMENTS = 'super-admin-financial-report/SET_CREATE_RECONCILIATION_PAYMENTS';
export const setCreateReconciliationPayments = (data: any, onComplete?: () => void) => ({
  meta: {
    onComplete,
  },
  type: SET_CREATE_RECONCILIATION_PAYMENTS,
  payload: data,
});

export const FETCH_CREATE_RECONCILIATION_PAYMENTS = 'super-admin-financial-report/FETCH_CREATE_RECONCILIATION_PAYMENTS';
export const fetchCreateReconciliationPayments = (data: any) => ({
  type: FETCH_CREATE_RECONCILIATION_PAYMENTS,
  payload: data,
});

export interface CreateReconciliationPaymentsAction
  extends Action<typeof SET_CREATE_RECONCILIATION_PAYMENTS>, OnCompleteAction {
  readonly payload: any;
}

export const SUPER_GET_RECONCILIATION_DELETE_ENTRIES =
  'super-admin-financial-report/SUPER_GET_RECONCILIATION_DELETE_ENTRIES';
export const getSuperReconciliationDeleteEntries = (data: any) => ({
  type: SUPER_GET_RECONCILIATION_DELETE_ENTRIES,
  payload: data,
});

export const SUPER_SET_RECONCILIATION_DELETE_ENTRIES =
  'super-admin-financial-report/SUPER_SET_RECONCILIATION_DELETE_ENTRIES';
export const setSuperReconciliationDeleteEntries = (data: any) => ({
  type: SUPER_SET_RECONCILIATION_DELETE_ENTRIES,
  payload: data,
});
//multiple client table//
export interface SuperSetReconciliationDeleteAction extends Action<typeof SUPER_SET_RECONCILIATION_DELETE_ENTRIES> {
  payload: any;
}
// print reconciliation

export const PRINT_RECONCILATION_DATA = 'super-admin-financial-report/PRINT_RECONCILATION_DATA';
export const printReconciliationData = (data: any) => ({
  type: PRINT_RECONCILATION_DATA,
  payload: data,
});
export const SET_PRINT_RECONCILATION_DATA = 'super-admin-financial-report/SET_PRINT_RECONCILATION_DATA';
export const setPrintReconciliationData = (data: any) => ({
  type: SET_PRINT_RECONCILATION_DATA,
  payload: data,
});

export interface SetPrintReconciliationDataAction extends Action<typeof SET_PRINT_RECONCILATION_DATA> {
  readonly payload: ReadonlyArray<any>;
}

// print reconcile payments
export const GET_SUPER_ADMIN_PRINT_RECONCILE_PAYMENTS =
  'super-admin-financial-report/GET_SUPER_ADMIN_PRINT_RECONCILE_PAYMENTS';
export const getSuperAdminPrintReconcilePaymentsReport = (data: any) => ({
  type: GET_SUPER_ADMIN_PRINT_RECONCILE_PAYMENTS,
  payload: data,
});
export const SET_SUPER_ADMIN_PRINT_RECONCILE_PAYMENTS =
  'super-admin-financial-report/SET_SUPER_ADMIN_PRINT_RECONCILE_PAYMENTS';
export const setSuperAdminPrintReconcilePaymentsReport = (data: any) => ({
  type: SET_SUPER_ADMIN_PRINT_RECONCILE_PAYMENTS,
  payload: data,
});

export interface SetSuperAdminPrintReconcilePaymentsAction extends Action<
  typeof SET_SUPER_ADMIN_PRINT_RECONCILE_PAYMENTS
> {
  readonly payload: any;
}

export type SuperAdminFinancialReportAction =
  | SuperSetReconciliationAction
  | CreateReconciliationAction
  | EditReconciliationAction
  | SuperSetReconciliationDeleteAction
  | SuperSetReconciliatioDataAction
  | SetPrintReconciliationDataAction
  | CreateReconciliationPaymentsAction
  | SuperSetReconciliatioAdjustmentDataAction
  | SetSuperAdminPrintReconcilePaymentsAction
  | SuperSetVehicleList
  | ClientSetReconcAction
  | SuperSetReconcAction;
